import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box, Grid, Card, Container, Stack, Button } from "@mui/material";
import { ComponentHeader, ContactMap } from "@/components/ui";
import { RichTextRenderer } from "@/components/renderers/RichTextRenderer";
import { PAGE_COPY } from "@/constants/pages";

export const ContactLocation = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 10 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <ContactMap />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: 4,
                border: "1px solid",
                borderColor: "divider",
                backgroundColor: "background.paper",
                height: { xs: "auto", md: "60vh" },
              }}
            >
              <ComponentHeader
                title={PAGE_COPY.sections.contactLocation.title}
                subTitle={PAGE_COPY.sections.contactLocation.subTitle}
                ta="left"
                mb={2}
                mt={0}
                component="h2"
              />

              <Stack spacing={2.5}>
                <Stack direction={{ sx: "column", md: "row" }}>
                  <Box sx={{ color: "text.secondary", lineHeight: 1.8 }}>
                    <RichTextRenderer content={PAGE_COPY.sections.contactLocation.content} />
                  </Box>
                  <Box flex={0.5} />
                  <Box sx={{ color: "text.secondary", lineHeight: 1.8 }}>
                    <RichTextRenderer content={PAGE_COPY.sections.contactLocation.contentUk} />
                  </Box>
                </Stack>
                <Stack direction="column" spacing={1.25}>
                  {PAGE_COPY.sections.contactLocation.phoneNumbers.map((phone) => (
                    <Button
                      key={phone.label}
                      href={phone.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="outlined"
                      startIcon={<WhatsAppIcon fontSize="large" />}
                      fullWidth
                      sx={{
                        textTransform: "none",
                        color: "text.primary",
                        borderColor: "text.primary",
                      }}
                    >
                      {phone.label}
                    </Button>
                  ))}
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
